const brand = {
  name: "BTCRuka",
  fullName: "BTCRuka Investment",
  domain: "btcrukainvestment.com",
  tag: "ENGINEERING / INFRASTRUCTURE / OPERATIONS",
  oneLiner: "An engineering-led technology and internet services firm.",
  pitch:
    "We design, ship and operate the technology backbone behind ambitious businesses. Software, networks, cloud, security and managed operations — delivered as a single, accountable engineering practice rather than a relay race of vendors.",
  contact: {
    email: "info@btcrukainvestment.com",
    hours: "Mon — Fri · 09:00 — 18:00 EET"
  },
  hq: {
    city: "Sofia",
    country: "Bulgaria",
    region: "Savski Venac · Triaditsa",
    address: {
      line1: "9 Pozitano Street, Floor 1, Shop 15",
      line2: "Triaditsa Region, Stolichna Municipality",
      line3: "Sofia 1000, Bulgaria"
    }
  },
  status: [
    { code: "01", label: "Engagements delivered", value: "180+", state: "active" },
    { code: "02", label: "Uptime across managed estates", value: "99.98%", state: "active" },
    { code: "03", label: "Industries served", value: "16", state: "review" },
    { code: "04", label: "Network operations cover", value: "24/7", state: "active" }
  ],
  industries: [
    "Financial Services",
    "Digital Markets",
    "Logistics & Trade",
    "Healthcare",
    "Manufacturing",
    "Real Estate",
    "Retail & E-commerce",
    "Public Sector"
  ]
};

export default brand;
